export default __webpack_public_path__ + "static/media/hexomatic-gift.52baf525.svg";